// @flow
import curry from 'lodash/curry'
import { get } from 'dot-prop-immutable'
import type { AppState } from '../../core/types'
import type { HashState } from './types'

const root = function(state: AppState): HashState {
  return state.hash
}

/**
 * Returns a single property from a hash
 * @param {Object} state Redux state
 * @param {String} hash  Hash key
 * @param {String} key   Key string or key path (xx.yy.zzz)
 */
export const hget = curry(function hget(
  hash: string,
  key: string,
  state: AppState
): any {
  const data = root(state)
  return get(data, [hash, key].join('.'))
})

type hGetAllType = (hashName: string, state?: {}) => any

export const hgetAll: hGetAllType = curry(function(
  hash: string,
  state: AppState
): ?Object {
  if (!hash) throw new Error('hgetAll expects a hash name!')
  return get(root(state), hash)
})

export const hkeys = curry(function hkeys(
  hash: string,
  state: AppState
): Array<string> {
  return Object.keys(get(root(state), hash) || {})
})

export const hlen = curry(function hlen(hash: string, state: AppState): number {
  return hkeys(hash, state).length
})

export const hexists = curry(function hexists(
  hash: string,
  key: string,
  state: AppState
): boolean {
  return Boolean(get(root(state), [hash, key].join('.')))
})



// WEBPACK FOOTER //
// ./src/modules/hash/selectors.js